import { columnForField, defaultColumnWidth } from "../../Grid/columnForField";
import OdcOverviewItem from "./OdcOverviewItem";
import { odcTypeColumnMenu, odcTypeEnumCell } from "./OdcTypeGridColumn";
import { customDecimalFilterCell } from "../../Layout/Filter/CustomDecimalFilterCell";

export const OdcGridColumns = () => {
  return [
    columnForField<OdcOverviewItem>("Gsdb", {
      title: "GSDB",
      locked: true,
      width: "175px",
    }),
    columnForField<OdcOverviewItem>("Name", { width: "300px" }),
    columnForField<OdcOverviewItem>("Details", { width: "300px" }),
    columnForField<OdcOverviewItem>("Street", { width: "300px" }),
    columnForField<OdcOverviewItem>("Zipcode", {
      title: "Postcode",
      width: defaultColumnWidth,
    }),
    columnForField<OdcOverviewItem>("ZipArea", {
      title: "Postcode Area",
      width: defaultColumnWidth,
    }),
    columnForField<OdcOverviewItem>("City", { width: "250px" }),
    columnForField<OdcOverviewItem>("CountryName", {
      title: "Country",
      width: defaultColumnWidth,
    }),
    columnForField<OdcOverviewItem>("Region", {
      width: defaultColumnWidth,
    }),
    columnForField<OdcOverviewItem>("Type", {
      hideFilterCell: true,
      columnMenu: odcTypeColumnMenu,
      cell: odcTypeEnumCell,
      width: defaultColumnWidth,
    }),
    columnForField<OdcOverviewItem>("HandlingTime", {
      title: "Inbound Handling Time",
      width: defaultColumnWidth,
    }),
    columnForField<OdcOverviewItem>("ReturnHandlingTime", {
      title: "Return Handling Time",
      width: defaultColumnWidth,
    }),
    columnForField<OdcOverviewItem>("Latitude", { width: "200px" }),
    columnForField<OdcOverviewItem>("Longitude", { width: "200px" }),
    columnForField<OdcOverviewItem>("MgLatitude", {
      title: "M&G Latitude",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: defaultColumnWidth,
    }),
    columnForField<OdcOverviewItem>("MgLongitude", {
      title: "M&G Longitude",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: defaultColumnWidth,
    }),
  ];
};
